export default "//cdn.scentbird.com/assets/frontbird-site/images/chocolate_d98ac7.jpg";